import EditHistoryBox from './EditHistoryBox';

export default EditHistoryBox;
